import { Chip } from '@mui/material';
import { OrderDocumentType, ORDER_DOCUMENT_TYPES } from '@/types/order-document';

export function getDocumentTypeChip(documentType: OrderDocumentType, t: (key: string) => string) {
  switch (documentType) {
    case ORDER_DOCUMENT_TYPES.PURCHASE_ORDER:
      return <Chip label={t('Purchase Order')} size="small" color="primary" variant="outlined" />;
    case ORDER_DOCUMENT_TYPES.DELIVERY_SHEET:
      return (
        <Chip label={t('Delivery Sheet (HES)')} size="small" color="secondary" variant="outlined" />
      );
    case ORDER_DOCUMENT_TYPES.EMAIL_APPROVAL:
      return <Chip label={t('Email Approval')} size="small" color="info" variant="outlined" />;
    case ORDER_DOCUMENT_TYPES.OTHER:
      return <Chip label={t('Other')} size="small" color="default" variant="outlined" />;
    default:
      return <Chip label={t('Unknown')} size="small" color="default" variant="outlined" />;
  }
}
